<template>
  <div class="descriptionPopup">
    <div>
      <!--购票说明-->
      <div class="BookingInstructions-div" style="padding-bottom: 0px">
        <van-skeleton title :row="3" title-width="80" :loading="loading">
          <p class="Quick-reply">预定说明</p>
          <div
            v-for="(item, index) in book_notice"
            :key="index"
            :class="item.key != '出票速度' ? 'BookingInstructions-padd' : ''"
          >
            <div v-if="item.key != '出票速度'">
              <p class="BookingDetails-title">
                {{ item.key }}
              </p>
              <p v-html="item.value" class="BookingDetails-content"></p>
            </div>
          </div>
          <p
            v-if="book_notice == '' || book_notice == null || book_notice == []"
            class="BookingDetails-information"
          >
            暂无信息
          </p>
        </van-skeleton>
      </div>

      <div class="BookingInstructions-div">
        <van-skeleton title :row="3" title-width="80" :loading="loading">
          <p class="Quick-reply">费用说明</p>
          <div
            v-for="(item, index) in cost_description"
            :key="'info' + index"
            class="BookingInstructions-padd"
          >
            <p class="BookingDetails-title">
              {{ item.key }}
            </p>
            <p v-html="item.value" class="BookingDetails-content"></p>
          </div>
          <p
            v-if="
              cost_description == '' ||
              cost_description == null ||
              cost_description == []
            "
            class="BookingDetails-information"
          >
            暂无信息
          </p>
        </van-skeleton>
      </div>

      <div class="BookingInstructions-div">
        <van-skeleton title :row="3" title-width="80" :loading="loading">
          <p class="Quick-reply">其他说明</p>
          <div
            v-for="(item, index) in other_description"
            :key="'info1' + index"
            class="BookingInstructions-padd"
          >
            <p class="BookingDetails-title">
              {{ item.key }}
            </p>
            <p v-html="item.value" class="BookingDetails-content"></p>
          </div>

          <p
            v-if="
              other_description == '' ||
              other_description == null ||
              other_description == []
            "
            class="BookingDetails-information"
          >
            暂无信息
          </p>
        </van-skeleton>
      </div>

      <div class="BookingInstructions-div">
        <van-skeleton title :row="3" title-width="80" :loading="loading">
          <p class="Quick-reply">退改说明</p>
          <div
            v-for="(item, index) in refund_change_rule"
            :key="'info2' + index"
            class="BookingInstructions-padd"
          >
            <p class="BookingDetails-title">
              {{ item.key }}
            </p>
            <p v-html="item.value" class="BookingDetails-content"></p>
          </div>

          <p
            v-if="
              refund_change_rule == '' ||
              refund_change_rule == null ||
              refund_change_rule == []
            "
            class="BookingDetails-information"
          >
            暂无信息
          </p>
        </van-skeleton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      book_notice: [],
      cost_description: [],
      other_description: [],
      refund_change_rule: [],
      loading: true,
    };
  },
  mounted() {
    this.TicketDetails();
  },
  methods: {
    TicketDetails() {
      this.$api
        .post("third-tickets/member/ticket/detail", {
          short_name: "PanHe",
          product_id: this.$route.query.product_id,
        })
        .then((res) => {
          //console.log(res)
          //购票须知弹窗
          this.book_notice = res.book_notice;
          this.cost_description = res.cost_description;
          this.other_description = res.other_description;
          this.refund_change_rule = res.refund_change_rule;
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.descriptionPopup {
  background: #fff;
  .van-skeleton {
    margin-top: 30px;
    padding-bottom: 10px;
    .van-skeleton__title {
      width: 90px;
       height: 25px;
      border-radius: 20px;
    }
    .van-skeleton__content {
      border-radius: 20px;
    }
    .van-skeleton__row {
      //  height: 50px;
      // margin: 17px 0px;
      border-radius: 20px;
    }
  }
  .Quick-reply {
    color: #333;
    font-weight: bold;
    padding-top: 20px;
    margin-bottom: 15px;
    padding-left: 20px;
  }
  .BookingInstructions-div {
    border-bottom: 5px solid #f3f8fb;
    padding-bottom: 20px;

    .BookingDetails-information {
      color: #666;
      font-size: 13px;
      font-weight: bold;
      padding-left: 20px;
    }
    .BookingInstructions-padd {
      padding: 0px 20px;
      margin-top: 20px;
      border-bottom: 1px solid #efefef;
      padding-bottom: 15px;
    }
    .BookingInstructions-padd:last-of-type {
      border-bottom: none;
    }
  }
  .BookingDetails-title {
    color: #333;
    font-size: 13px;
    font-weight: bold;
  }

  .BookingDetails-content {
    font-size: 13px;
    color: #999;
    line-height: 20px;
    background: #fff;
    margin-top: 10px;
    /deep/ img {
      width: 100%;
      margin: 10px 0px;
    }
  }
}
</style>
